import { BpmnModel, ExclusiveGateway, ParallelGateway, EndEvent, InclusiveGateway } from "@edp-pmf/bpmn-model";
import { ProcessHeader, Component, StartMode, ToolTime, StartActivity, UserActivity, OperationActivity, AutoActivity, MessageActivity, CallActivitySubProcess, IntermediateCatchEventImpl, NotifyActivity, AifCreationBillActivity, ExecuteWorkItemMode } from "@gsp-wf/wf-process-model";
import { WfDesignerUtils } from "./WfDesignerUtils";
import { WfValidationResult } from "./WfValidationResult";
import { WfLocalePipe } from "../i18n/pipe/wf-process-editor-locale.pipe";

export class WfValidatorAdapter {
  public static localePipe: WfLocalePipe = null;

  constructor() {
    
  }
    static validator(bpmnModel: BpmnModel, scene: string): WfValidationResult {
        // 校验节点标识是否合规
        const resActList = this.validateActivityList(bpmnModel);
        if (!resActList.valid) {
            return resActList;
        }
        // 校验流程变量
        const resProcVars = this.validatePrcoessVaris(bpmnModel);
        if (!resProcVars.valid) {
            return resProcVars;
        }
        //校验会签规则
        const resSignRule = this.validateSignRules(bpmnModel);
        if(!resSignRule.valid) {
          return resSignRule;
        }

        const warningList = this.warningValidator(bpmnModel, scene)
        return {
            valid: true,
            warningList: warningList,
        };
    }

  private static warningValidator(bpmnModel: BpmnModel, scene: string) {
    let warningList = new Array();
    // 校验并行网关是否成对出现
    this.validateParallelGateway(bpmnModel, warningList);
    // 校验包容网关是否成对出现
    this.validateInclusiveGateway(bpmnModel, warningList);
    // 校验流程构件
    this.validateProcCmps(bpmnModel, scene, warningList);
    // 校验审批活动、人工操作参与者
    this.validateApprovalPerformers(bpmnModel, warningList);
    // 校验知会节点的知会接收人
    this.validateNotifyPerformers(bpmnModel, warningList);

    return warningList;
  }

  private static validateProcCmps(bpmnModel: BpmnModel, scene: string, warningList: Array<any>) {
    if (scene === 'inSuite') {
      return;
    }
    const extendElements = bpmnModel.DefaultProcess.GetExtensionElements();
    const processHeader = extendElements.find(e => e instanceof ProcessHeader);
    if (!processHeader) {
      console.error(this.localePipe.instant('validate.noProcessHeader'))
      return;
    }
    const procCmps = extendElements.filter(e => e instanceof Component);
    if (!procCmps || procCmps.length === 0) {
      const tip = {
        id: 'lackCmp',
        title: this.localePipe.instant('validate.cmpsEmpty'),
        msg: this.localePipe.instant('validate.cmpsEmptyMsg'),
        type: 'processWarning'
      };
      warningList.push(tip);
      return;
    }
    // 启用方式为直接方式时
    if ((processHeader as ProcessHeader).startMode === StartMode.DIRECT) {
      // 直接启用方式时不允许存在共享的构件
      const pfCmps = procCmps.filter((p: Component) => WfDesignerUtils.isPfComponent(p.MetadataId));
      if (pfCmps && pfCmps.length > 0) {
        let pfCmpsName = '';
        for (const cmp of pfCmps) {
          pfCmpsName = pfCmpsName.concat(`${(cmp as Component).Name}, `);
        }
        pfCmpsName = pfCmpsName.slice(0, pfCmpsName.length - 1);
        const tip = {
          id: 'directProcessWithPFCmp',
          title: this.localePipe.instant('validate.directNoPf'),
          msg: this.localePipe.instant('validate.directNoPfMsg')+`${pfCmpsName} `,
          type: 'processWarning'
        };
        warningList.push(tip);
      }
      if (!procCmps.some((c: Component) => c.Time === ToolTime.LOADDATA)) {
        const tip = {
          id: 'lackLoadDataCmp',
          title: this.localePipe.instant('validate.noLoadDataCmp'),
          msg: this.localePipe.instant('validate.noLoadDataCmpMsg'),
          type: 'processWarning'
        };
        warningList.push(tip);
      }
      if (!procCmps.some((c: Component) => c.Time === ToolTime.PROCESSINSTANCE_STARTED)) {
        const tip = {
          id: 'lackProcessStartCmp',
          title: this.localePipe.instant('validate.noStartCmp'),
          msg: this.localePipe.instant('validate.noStartCmpMsg'),
          type: 'processWarning'
        };
        warningList.push(tip);
      }
      if (!procCmps.some((c: Component) => c.Time === ToolTime.PROCESSINSTANCE_COMPLETED)) {
        const tip = {
          id: 'lackProcessCompleteCmp',
          title: this.localePipe.instant('validate.lackProcessCompleteCmp'),
          msg: this.localePipe.instant('validate.lackProcessCompleteCmpMsg'),
          type: 'processWarning'
        };
        warningList.push(tip);
      }
      if (!procCmps.some((c: Component) => (c.Time as any) === 'PROCESSINSTANCE_ABORTED')) {
        const tip = {
          id: 'lackProcessAbortCmp',
          title: this.localePipe.instant('validate.lackProcessAbortCmp'),
          msg: this.localePipe.instant('validate.lackProcessAbortCmpMsg'),
          type: 'processWarning'
        };
        warningList.push(tip);
      }
      if (!procCmps.some((c: Component) => c.Time === 'PROCESSINSTANCE_CANCELED')) {
        const tip = {
          id: 'lackProcessCancelCmp',
          title: this.localePipe.instant('validate.lackProcessCancelCmp'),
          msg: this.localePipe.instant('validate.lackProcessCancelCmpMsg'),
          type: 'processWarning'
        };
        warningList.push(tip);
      }
      if (!procCmps.some((c: Component) => c.Time === 'PROCESSINSTANCE_ROLLBACK')) {
        const tip = {
          id: 'lackProcessBackCmp',
          title: this.localePipe.instant('validate.lackProcessBackCmp'),
          msg: this.localePipe.instant('validate.lackProcessBackCmpMsg'),
          type: 'processWarning'
        };
        warningList.push(tip);
      }
      if (!procCmps.some((c: Component) => c.Time === 'PROCESSINSTANCE_RESUBMIT')) {
        const tip = {
          id: 'lackProcessReStartCmp',
          title: this.localePipe.instant('validate.lackProcessReStartCmp'),
          msg: this.localePipe.instant('validate.lackProcessReStartCmpMsg'),
          type: 'processWarning'
        };
        warningList.push(tip);
      }
    }
  }

  private static validateParallelGateway(bpmnModel: BpmnModel, warningList: Array<any>) {
    const flowElements = bpmnModel.DefaultProcess.GetFlowElements();
    let parallelGatewayCount = 0;
    for (const k in flowElements) {
      if (flowElements[k] instanceof ParallelGateway) {
        parallelGatewayCount++;
      }
    }
    if (parallelGatewayCount % 2 !== 0) {
      const tip = {
        id: 'parallelGatewayCheck',
        title: this.localePipe.instant('validate.parallelGatewayCheck'),
        msg: this.localePipe.instant('validate.parallelGatewayCheckMsg'),
        type: 'processWarning'
      };
      warningList.push(tip);
    }
  }

  private static validateInclusiveGateway(bpmnModel: BpmnModel, warningList: Array<any>) {
    const flowElements = bpmnModel.DefaultProcess.GetFlowElements();
    let inclusiveGatewayCount = 0;
    for (const k in flowElements) {
      if (flowElements[k] instanceof InclusiveGateway) {
        inclusiveGatewayCount++;
      }
    }
    if (inclusiveGatewayCount % 2 !== 0) {
      const tip = {
        id: 'inclusiveGatewayCheck',
        title: this.localePipe.instant('validate.inclusiveGatewayCheck'),
        msg: this.localePipe.instant('validate.inclusiveGatewayCheckMsg'),
        type: 'processWarning'
      };
      warningList.push(tip);
    }
  }

  private static validateApprovalPerformers(bpmnModel: BpmnModel, warningList: any[]) {
    const flowElements = bpmnModel.DefaultProcess.GetFlowElements();
    let count = 0;
    for (const k in flowElements) {
      const act = flowElements[k];
      if (act instanceof UserActivity || act instanceof OperationActivity) {
        const roles = act.GetResourceRoles();
        if (roles.length == 0 && (!act.AssignPerformerConfig || !act.AssignPerformerConfig.AllowGlobalAssign)) {
          const nameLanguage = flowElements[k].NameLanguage ? (flowElements[k].NameLanguage[this.localePipe.langCode] ? flowElements[k].NameLanguage[this.localePipe.langCode] : flowElements[k].Name ) : flowElements[k].Name;
          const tip = {
            id: 'approvalPerformerCheck' + count,
            title: `【${nameLanguage}】` +  this.localePipe.instant('validate.approvalPerformerCheck'),
            msg: ``,
            type: 'processWarning'
          };
          warningList.push(tip);

          count++;
        }
      }
    }
  }

  private static validateNotifyPerformers(bpmnModel: BpmnModel, warningList: any[]) {
    const flowElements = bpmnModel.DefaultProcess.GetFlowElements();
    let count = 0;
    for (const k in flowElements) {
      const act = flowElements[k];
      if (act instanceof NotifyActivity) {
        const roles = act.GetResourceRoles();
        if (roles.length == 0) {
          const nameLanguage = flowElements[k].NameLanguage ? (flowElements[k].NameLanguage[this.localePipe.langCode] ? flowElements[k].NameLanguage[this.localePipe.langCode] : flowElements[k].Name ) : flowElements[k].Name;
          const tip = {
            id: 'approvalPerformerCheck' + count,
            title: `【${nameLanguage}】` +  this.localePipe.instant('validate.notifyPerformerCheck'),
            msg: ``,
            type: 'processWarning'
          };
          warningList.push(tip);

          count++;
        }
      }
    }
  }

  private static validateSignRules(bpmnModel: BpmnModel) {
    const flowElements = bpmnModel.DefaultProcess.GetFlowElements();
    let count = 0;
    for (const k in flowElements) {
      const act = flowElements[k];
      if (act instanceof UserActivity || act instanceof OperationActivity) {
        const executeWorkItemMode = act.ExecuteWorkItemMode;
        if(executeWorkItemMode && executeWorkItemMode !== ExecuteWorkItemMode.Preempt) {
          const signRules = act.CounterSignRules;
          if(!signRules || signRules.length == 0) {
            return {
              valid: false,
              type: 'message',
              level: 'warning',
              message: `【${flowElements[k].Name}】`+  this.localePipe.instant('validate.noSignRule')
            }
          }
        }
      }
    }
    return {
      valid: true,
    };
  }

  private static validatePrcoessVaris(bpmnModel: BpmnModel) {
    const objects = bpmnModel.DefaultProcess.GetDataObjects();
    let procVaris = new Array();
    if (objects && objects.length > 0) {
      procVaris = objects.filter(o => o.DataType.Category !== 'CustomType').map(o => o.Name);
    }
    const flowElements = bpmnModel.DefaultProcess.GetFlowElements();
    for (const k in flowElements) {
      if (flowElements[k] instanceof UserActivity ||
        flowElements[k] instanceof OperationActivity ||
        flowElements[k] instanceof AutoActivity ||
        flowElements[k] instanceof MessageActivity ||
        flowElements[k] instanceof CallActivitySubProcess ||
        flowElements[k] instanceof IntermediateCatchEventImpl ||
        flowElements[k] instanceof NotifyActivity) {
        const variSets = (flowElements[k] as any).variableSettings;
        if (variSets) {
          for (const v of variSets) {
            if (!procVaris.some(p => p === v.variableCode)) {
              return {
                valid: false,
                type: 'message',
                level: 'warning',
                message: `【${flowElements[k].Name}】`+  this.localePipe.instant('validate.noVariable1')
                +`【${v.variableName}】`+ this.localePipe.instant('validate.noVariable2')
              }
            }
          }
        }
      }
    }
    return {
      valid: true,
    };
  }

  private static validateActivityList(bpmnModel: BpmnModel) {
    const flowElements = bpmnModel.DefaultProcess.GetFlowElements();
    const resActId = this.validateActivityId(flowElements);
    if (!resActId.valid) {
      return resActId;
    }
    const resActName = this.validateActivityName(flowElements);
    if (!resActName.valid) {
      return resActName;
    }
    return {
      valid: true,
    };
  }

  private static validateActivityId(flowElements: any) {
    for (const k in flowElements) {
      switch (flowElements[k].ClrTypeID) {
        case 'wf.StartActivity':
          const startActivity = flowElements[k] as StartActivity;
          if (!startActivity.Id.startsWith('startActivity')) {
            return {
              valid: false,
              type: 'message',
              level: 'error',
              message: this.localePipe.instant('validate.activity') +
              `${startActivity.Name}`+ this.localePipe.instant('validate.noStartActivity')
            };
          }
          break;
        case 'bpmn.ExclusiveGateway':
          const exclusiveGateway = flowElements[k] as ExclusiveGateway;
          if (!exclusiveGateway.Id.startsWith('ExclusiveGateway')) {
            return {
              valid: false,
              type: 'message',
              level: 'error',
              message: this.localePipe.instant('validate.activity') +
              `${exclusiveGateway.Name}`+ this.localePipe.instant('validate.noExclusiveGateway')
            }
          }
          break;
        case 'bpmn.ParallelGateway':
          const parallelGateway = flowElements[k] as ParallelGateway;
          if (!parallelGateway.Id.startsWith('ParallelGateway')) {
            return {
              valid: false,
              type: 'message',
              level: 'error',
              message: this.localePipe.instant('validate.activity') +
              `${parallelGateway.Name}`+ this.localePipe.instant('validate.noParallelGateway')
            };
          }
          break;
        case 'wf.UserActivity':
          const userActivity = flowElements[k] as UserActivity;
          if (!userActivity.Id.startsWith('UserActivity')) {
            return {
              valid: false,
              type: 'message',
              level: 'error',
              message: this.localePipe.instant('validate.activity') +
              `${userActivity.Name}`+ this.localePipe.instant('validate.noUserActivity')
            };
          }
          break;
        case 'wf.OperationActivity':
          const operationActivity = flowElements[k] as OperationActivity;
          if (!operationActivity.Id.startsWith('UserActivity')) {
            return {
              valid: false,
              type: 'message',
              level: 'error',
              message: this.localePipe.instant('validate.activity') +
              `${operationActivity.Name}`+ this.localePipe.instant('validate.noOperationActivity')
            };
          }
          break;
        case 'wf.NotifyActivity':
          const notifyActivity = flowElements[k] as NotifyActivity;
          if (!notifyActivity.Id.startsWith('NotifyActivity')) {
            return {
              valid: false,
              type: 'message',
              level: 'error',
              message: this.localePipe.instant('validate.activity') +
              `${notifyActivity.Name}`+ this.localePipe.instant('validate.noNotifyActivity')
            };
          }
          break;
        case 'wf.CallActivitySubProcess':
          const callActivitySubProcess = flowElements[k] as CallActivitySubProcess;
          if (!callActivitySubProcess.Id.startsWith('CallActivitySubProcess')) {
            return {
              valid: false,
              type: 'message',
              level: 'error',
              message: this.localePipe.instant('validate.activity') +
              `${callActivitySubProcess.Name}`+ this.localePipe.instant('validate.noCallActivitySubProcess')
            };
          }
          break;
        case 'wf.AutoActivity':
          const autoActivity = flowElements[k] as AutoActivity;
          if (!autoActivity.Id.startsWith('autoActivity')) {
            return {
              valid: false,
              type: 'message',
              level: 'error',
              message: this.localePipe.instant('validate.activity') +
              `${autoActivity.Name}`+ this.localePipe.instant('validate.noAutoActivity')
           };
          }
          break;
        case 'wf.IntermediateCatchEventImpl':
          const intermediateCatchEventImpl = flowElements[k] as IntermediateCatchEventImpl;
          if (!intermediateCatchEventImpl.Id.startsWith('IntermediateCatchEvent')) {
            return {
              valid: false,
              type: 'message',
              level: 'error',
              message: this.localePipe.instant('validate.activity') +
              `${intermediateCatchEventImpl.Name}`+ this.localePipe.instant('validate.noIntermediateCatchEvent')
            };
          }
          break;
        case 'wf.MessageActivity':
          const messageActivity = flowElements[k] as MessageActivity;
          if (!messageActivity.Id.startsWith('MessageActivity')) {
            return {
              valid: false,
              type: 'message',
              level: 'error',
              message: this.localePipe.instant('validate.activity') +
              `${messageActivity.Name}`+ this.localePipe.instant('validate.noMessageActivity')
            };
          }
          break;
        case 'wf.AifCreationBillActivity':
          const aifCreationBillActivity = flowElements[k] as AifCreationBillActivity;
          if (!aifCreationBillActivity.Id.startsWith('AifCreationBillActivity')) {
            return {
              valid: false,
              type: 'message',
              level: 'error',
              message: this.localePipe.instant('validate.activity') +
              `${aifCreationBillActivity.Name}`+ this.localePipe.instant('validate.noAifCreationBillActivity')
            };
          }
          break;
        case 'bpmn.EndEvent':
          const endEvent = flowElements[k] as EndEvent;
          if (!endEvent.Id.startsWith('EndEvent')) {
            return {
              valid: false,
              type: 'message',
              level: 'error',
              message: this.localePipe.instant('validate.activity') +
              `${endEvent.Name}`+ this.localePipe.instant('validate.noEndEvent')
            };
          }
          break;
      }
    }
    return {
      valid: true,
    };
  }

  private static validateActivityName(flowElements: any) {
    for (const k in flowElements) {
      const flowNode = flowElements[k];
      switch (flowNode.ClrTypeID) {
        case "wf.StartActivity":
        case "bpmn.ExclusiveGateway":
        case "bpmn.ParallelGateway":
        case "wf.UserActivity":
        case "wf.OperationActivity":
        case "wf.NotifyActivity":
        case "wf.CallActivitySubProcess":
        case "wf.AutoActivity":
        case "wf.IntermediateCatchEventImpl":
        case "wf.MessageActivity":
        case "wf.AifCreationBillActivity":
        case "bpmn.EndEvent":
          if (flowNode.Name == null || flowNode.Name == "") {
            return {
              valid: false,
              type: 'message',
              level: 'error',
              message: this.localePipe.instant('validate.mark') +
               `${flowNode.Id}` + this.localePipe.instant('validate.noFlowNodeChsName')
            };
          }
          if (new Blob([flowNode.Name]).size > 128) {
            return {
              valid: false,
              type: 'message',
              level: 'error',
              message: this.localePipe.instant('validate.activity') +
              `${flowNode.Name}` + this.localePipe.instant('validate.nameExceedsLengthLimit')
            };
          }
          break;
      };
    }
    return {
      valid: true,
    };
  }

}
